module.exports = __webpack_public_path__ + "3c482a6412f1cf9689e5e1e7a6abd787.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/3.png
// module id = 539
// module chunks = 21 54 55 56 77 79 80 88